import { z } from 'zod';

const datelikeInput = z.union([z.number(), z.string(), z.date()]);
export const DatelikeSchema = datelikeInput.pipe(z.coerce.date());
export type DatelikeInput = z.input<typeof DatelikeSchema>;
